import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLimit: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconLimit"><Path d="M12 13L8.75 9.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><Path d="M5.17886 19.248C1.84946 15.6186 1.94293 9.97559 5.45926 6.45926C9.07161 2.84691 14.9284 2.84691 18.5407 6.45926C22.0571 9.97559 22.1505 15.6186 18.8211 19.248" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconLimit;
